module.exports = __webpack_public_path__ + "img/carriage-yes.614edfd2.png";